import React from 'react';
import { Tag } from '../../../../../../../common/tags/tagTypes';
import { isEmpty } from 'lodash';
import TagsListElement from './TagsListElement';

type TagsListProps = {
    tagsArray: Array<Tag>;
    handleClickTag: (tag: Tag) => void;
    handleClickEdit: (tag: Tag) => void;
    isSelected?: boolean;
};

const TagsList: React.FC<TagsListProps> = ({ tagsArray, handleClickTag, handleClickEdit, isSelected }) => {
    if (isEmpty(tagsArray)) return null;

    return (
        <div className={`TagsList mb-3`}>
            {tagsArray.map((tag) => (
                <TagsListElement
                    key={tag.id}
                    tag={tag}
                    isSelected={isSelected}
                    handleClickTag={handleClickTag}
                    handleClickEdit={handleClickEdit}
                />
            ))}
        </div>
    );
};

export default TagsList;
